import { FC } from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { cn } from '@fe-learner-common';

export interface RadioButtonProps {
  className?: string;
  id: string;
  size: 'sm' | 'md' | 'lg';
  value: string;
}

export const radioButtonSizeMap = {
  sm: 'lf:h-4 lf:w-4',
  md: 'lf:h-5 lf:w-5',
  lg: 'lf:h-6 lf:w-6',
};

const dotSizeMap = {
  sm: 'lf:after:w-2 lf:after:h-2',
  md: 'lf:after:w-2.5 lf:after:h-2.5',
  lg: 'lf:after:w-3 lf:after:h-3',
};

export const RadioButton: FC<RadioButtonProps> = ({
  value,
  className,
  size,
  id,
}) => {
  return (
    <RadioGroupPrimitive.Item
      className={cn(
        'lf:cursor-pointer lf:rounded-full lf:border lf:border-neutral-300 lf:bg-neutral-0 lf:hover:border-neutral-400 lf:data-[state=checked]:border-prominence-500',
        radioButtonSizeMap[size],
        className,
      )}
      value={value}
      id={id}
    >
      <RadioGroupPrimitive.Indicator
        className={cn(
          "lf:relative lf:flex lf:h-full lf:w-full lf:items-center lf:justify-center lf:after:block lf:after:rounded-[50%] lf:after:bg-prominence-500 lf:after:content-['']",
          dotSizeMap[size],
        )}
      />
    </RadioGroupPrimitive.Item>
  );
};
